<template>
  <div class="form">
    <div class="form-item">
      <span class="label">原保单号</span>
      <span class="value">{{ formData.policyNo }}</span>
    </div>

    <div class="form-item">
      <span class="label">产品名称</span>
      <span class="value">{{ formData.productName }}</span>
    </div>

    <div class="form-item">
      <span class="label">产品类型</span>
      <span class="value" v-if='formData.sellType&&formData.sellType.includes("1")'>网销产品</span>
      <span class="value" v-if='formData.sellType&&formData.sellType.includes("2")'>电销产品</span>
      <span class="value" v-if='formData.sellType&&formData.sellType.includes("3")'>线下产品</span>
    </div>

    <div class="form-item">
      <span class="label">保险公司</span>
      <span class="value">{{ formData.companyName }}</span>
    </div>

    <div class="form-item">
      <span class="label">新保单号</span>
      <span class="value">{{ formData.newPolicyNo|filterNull }}</span>
    </div>

    <div class="form-item">
      <span class="label">原保单状态</span>
      <span class="value">{{ formData.policyStatus|filterInsureOrderStatus }}</span>
    </div>

    <div class="form-item">
      <span class="label">保单到期日</span>
      <span class="value">{{ filterTime(formData.policyEndDate, 'YYYY-MM-DD') }}</span>
    </div>

    <div class="form-item">
      <span class="label">续保状态</span>
      <span class="value">{{ formData.payState|filterStatus }}</span>
    </div>
    <div class="form-item">
      <span class="label">保单生效日</span>
      <span class="value">{{ filterTime(formData.policyStartDate, 'YYYY-MM-DD')}}</span>
    </div>

    <div class="form-item" v-if="formData.isRenewal != 0">
      <span class="label">最晚续保日</span>
      <span class="value">{{ filterTime(formData.latestRenewalDate, 'YYYY-MM-DD') }}</span>
    </div>

    <div class="form-item">
      <span class="label">原单保费(元)</span>
      <span class="value">{{ formData.fee }}元</span>
    </div>

    <div class="form-item">
      <span class="label">续保保费(元)</span>
      <span class="value">{{ formData.payFee?formData.payFee + '元':'-' }}</span>
    </div>

    <div class="form-item">
      <span class="label">服务费(元)</span>
      <span class="value">{{ formData.commissionPrice }}元</span>
    </div>

    <div class="form-item">
      <span class="label">产品来源</span>
      <span class="value" v-if="formData.sourceType == 1">线上产品</span>
      <span class="value" v-else>线下产品</span>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
  props: {
    // 列表详情
    formData: {
      default: () => {},
      type: Object,
    },

    // 缴费状态
    status: {
      default: '',
      type: String,
    }
  },

  filters: {
    filterNull(val){
      if(!val){
        return '-'
      }
      return val
    },

    //保单状态
    filterInsureOrderStatus(num) {
      const m = new Map([
        ["1", "已承保"],
        ["-1", "已退保"],
        ["0", "已终止"],
        ["2", "已中止"],
      ]);
      return m.get(num + "");
    },

    // 续保状态
    filterStatus(num) {
      const m = new Map([
        ["1", "待续保"],
        ["2", "续保成功"],
        ["3", "续保失败"],
      ]);
      return m.get(num + "");
    }
  },

  methods: {
    //日期处理
    filterTime(val, format) {
      if(!val){
        return '-'
      }
      if (val) {
        format = format || "YYYY-MM-DD HH:mm:ss";
        return dayjs(val).format(format);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.form {
  margin: 20px 0 30px 0;
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  .form-item {
    margin-bottom: 15px;
    display: flex;
    width: 25%;
    .label {
      width: 120px;
      white-space: nowrap;
      display: block;
      text-align: right;
      margin-right: 20px;
      font-size: 14px;
      color: #666e7b;
    }
    .value {
      width: 80%;
      color: #272933;
    }
  }
}
</style>